<template>
    <SimpleForm api="summarizer" title="Summarizer" id="summarizer" :fields="fields"/>
</template>

<script>

import SimpleForm from '../../../components/forms/SimpleForm.vue';

const formFields = [
    ['enabled', {component: 'otif-switch'}],
    'name',
    'encoding',
    'startSummaryLength',
    'endSummaryLength',
    'summaryMarker',
    'alternateSummaryField'
];

export default {
    data() {
        return {
            fields: formFields
        }
    },

    components: {
        SimpleForm
    }
}

</script>
